import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";

import {
  FaUsers,
  FaUserPlus,
  FaDollarSign,
  FaArrowUp,
  FaStar,
  FaArrowRight,
  FaArrowDown,
  FaUtensils,
  FaShoppingCart,
  FaHeadset,
  FaHandshake,
  FaCogs,
  FaFlag,
} from "react-icons/fa";
import axiosInstance from "../axiosInstance";
import logo from "../images/logo1.png"; // Update the path to your user image logo
import mainpic from "../images/main.png"; // Update the path to your user image logo
import dashboard from "../images/foodordero.gif"; // Update the path to your user image logo

const HomePage = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(AuthContext);

  const progressDuration = 7000; // Duration for the progress bar to fill (7 seconds)
  const [showButton, setShowButton] = useState(false);

  //write a function to get users local time zone

  
  const handleSignInClick = () => {
    navigate("/login");
  };

  const handleSignUpClick = (url) => {
    navigate("/register");
  };

  // Detect scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const testimonials = [
    {
      name: "Alice Johnson",
      message:
        "FoodOrderoo made it incredibly easy to place my order right from my table. I loved how simple and affordable the process was!",
      rating: 5,
    },
    {
      name: "Michael Lee",
      message:
        "As a restaurant owner, using FoodOrderoo has streamlined my operations. It's very affordable, and my customers enjoy the convenience!",
      rating: 5,
    },
    {
      name: "Samantha Green",
      message:
        "The app is user-friendly, making ordering food a breeze. I can't believe how much easier dining out has become!",
      rating: 4,
    },
    {
      name: "David Kim",
      message:
        "FoodOrderoo is fantastic! I can quickly order food with just a few taps on my phone. It saves me time.",
      rating: 5,
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000); // Change testimonials every 5 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div className="bg-gray-100 overflow-x-hidden">
      {showButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-5 right-5 p-3 rounded-full shadow-lg hover:opacity-90 transition-opacity"
          style={{
            background: "linear-gradient(to right, #6A5ACD, #00BFFF)", // Gradient color
            color: "white",
            zIndex: 1000,
          }}
        >
          <FaArrowUp size={20} /> {/* FontAwesome arrow up icon */}
        </button>
      )}
      <section className="flex flex-col items-center justify-center bg-white py-12 px-6 relative overflow-hidden">
        {/* Logo and Branding */}
        <div className="mb-6">
          <img
            src={mainpic}
            alt="FoodOrderoo logo"
            className="w-auto h-auto md:h-60 transition-transform duration-300 hover:scale-110"
          />
        </div>

        {/* Headline */}
        <h1 className="text-3xl font-bold text-gray-600 text-center mb-4">
          QR Code food Ordering Solution for Restaurants
        </h1>

        {/* Clear Description */}
        <p className="text-gray-700 text-center mb-6 max-w-3xl">
          With FoodOrderoo, restaurants can offer a seamless and cost-effective
          dining experience. Customers can simply scan a QR code, browse the
          menu, and place their order—straight from their phone. It's fast,
          easy, and eliminates the need for expensive hardware or complex
          systems. Enjoy effortless service and satisfied diners at the best
          price. Only pay $1 per order. No hidden fees, no contracts, and no upfront. 
        </p>

        {/* Call to Action Buttons */}

        {isLoggedIn ? (
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-blue-500 text-white font-bold py-3 px-8 rounded-lg shadow-md hover:bg-blue-600 transition duration-300 transform hover:scale-105"
          >
            Go to Dashboard
          </button>
        ) : (
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={handleSignInClick}
              className="bg-blue-500 text-white font-bold py-3 px-8 rounded-lg shadow-md hover:bg-blue-600 transition duration-300 transform hover:scale-105"
            >
              Sign In
            </button>
            <button
              onClick={handleSignUpClick}
              className="bg-green-500 text-white font-bold py-3 px-8 rounded-lg shadow-md hover:bg-green-600 transition duration-300 transform hover:scale-105"
            >
              Sign Up
            </button>
          </div>
        )}

        {/* Explanation for Restaurant Owners */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
          {/* For Restaurant Owners */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
            <h3 className="text-2xl font-semibold mb-4 text-green-600">
              For Restaurant Owners
            </h3>
            <p className="text-gray-600 mb-4">
              Join the FoodOrderoo platform and let your customers order
              effortlessly from their tables. Increase your restaurant's
              efficiency and serve more customers with less waiting time. By
              reducing labor costs, restaurant owners can save a lot of money
              while enhancing the dining experience. Partner with us today!
            </p>
          </div>

          {/* For Food Lovers */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
            <h3 className="text-2xl font-semibold mb-4 text-blue-600">
              For Food Lovers
            </h3>
            <p className="text-gray-600 mb-4">
              Food lovers can quickly order their favorite meals right from
              their phones, ensuring a delightful dining experience without the
              hassle of waiting in line. Enjoy the convenience of fast and easy
              ordering with Ordero!
            </p>
          </div>
        </div>
      </section>

      {/* New Pricing Section */}
      <section className="bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">Pricing</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* No Upfront Cost */}
            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className="flex justify-center mb-4">
                <FaDollarSign className="text-green-600 text-4xl" />
              </div>
              <h3 className="text-2xl font-semibold text-green-600 mb-4">
                Low cost for restaurants
              </h3>
              <p className="text-gray-600 mb-4">
                Restaurant will be only charged service fees $1 per order and that's it. This ensures there are no hidden
                fees or extra costs for you as a business. Pay only as you
                receive orders—it's a risk-free solution to start growing your
                business.
              </p>
            </div>

            {/* No Contracts */}
            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className="flex justify-center mb-4">
                <FaHandshake className="text-blue-600 text-4xl" />
              </div>
              <h3 className="text-2xl font-semibold text-blue-600 mb-4">
                No Contracts or Lockups
              </h3>
              <p className="text-gray-600 mb-4">
                Our pricing is flexible— no long-term contract. Start using the
                app anytime and stop without any obligations.
              </p>
            </div>

            {/* Easy Setup */}
            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className="flex justify-center mb-4">
                <FaCogs className="text-yellow-600 text-4xl" />
              </div>
              <h3 className="text-2xl font-semibold text-yellow-600 mb-4">
                Easy Setup & Support
              </h3>
              <p className="text-gray-600 mb-4">
                Quick and easy to set up with 7 days of customer support. Get
                your restaurant ready to take orders in minutes.
              </p>
            </div>

            {/* Proudly Australian */}
            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className="flex justify-center mb-4">
                <FaFlag className="text-red-600 text-4xl" />
              </div>
              <h3 className="text-2xl font-semibold text-red-600 mb-4">
                Proudly Australian
              </h3>
              <p className="text-gray-600 mb-4">
                FoodOrderoo is built by a proud Australian software company,
                supporting local businesses with affordable, transparent
                pricing.
              </p>
            </div>
          </div>
 
        </div>
      </section>  
      <section className="flex flex-col items-center justify-center bg-white py-12 px-6 relative overflow-hidden">
        {/* Logo and Branding */}
        <div className="mb-6">
          <img
            src={dashboard}
            alt="FoodOrderoo logo"
            className="w-auto h-auto md:h-80 transition-transform duration-300 hover:scale-110"
          />
        </div>
        </section>

      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            Simplify Your Ordering Process
          </h2>

          <div className="relative">
            {/* Grid for steps */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Step 1: Sign Up */}
              <Link
                to="/register"
                className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-2xl transition-shadow duration-300 transform hover:scale-105"
              >
                <div className="mb-4">
                  <FaUserPlus
                    size={40}
                    className="mx-auto text-blue-500 transition-transform duration-300 hover:rotate-12"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                  1. Sign Up
                </h3>
                <p className="text-gray-600">
                  Create your account in minutes by entering your restaurant
                  details.
                </p>
              </Link>

              {/* Horizontal Arrow between Step 1 and Step 2 for Desktop */}
              <div className="hidden md:block absolute inset-y-1/2 left-1/3 w-1/3">
                <div className="flex justify-center">
                  <span className="inline-block w-10 h-1 bg-gray-300"></span>
                  <FaArrowRight className="text-gray-500" size={30} />
                </div>
              </div>

              {/* Vertical Arrow between Step 1 and Step 2 for Mobile */}
              <div className="md:hidden flex justify-center">
                <FaArrowDown className="text-gray-500" size={30} />
              </div>

              {/* Step 2: Add Your Menu */}
              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-2xl transition-shadow duration-300 transform hover:scale-105">
                <div className="mb-4">
                  <FaUtensils
                    size={40}
                    className="mx-auto text-green-500 transition-transform duration-300 hover:rotate-12"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                  2. Add Your Menu
                </h3>
                <p className="text-gray-600">
                  Showcase your delicious dishes by adding your menu items
                  easily.
                </p>
              </div>

              {/* Horizontal Arrow between Step 2 and Step 3 for Desktop */}
              <div className="hidden md:block absolute inset-y-1/2 left-2/3 w-1/3">
                <div className="flex justify-center">
                  <span className="inline-block w-10 h-1 bg-gray-300"></span>
                  <FaArrowRight className="text-gray-500" size={30} />
                </div>
              </div>

              {/* Vertical Arrow between Step 2 and Step 3 for Mobile */}
              <div className="md:hidden flex justify-center">
                <FaArrowDown className="text-gray-500" size={30} />
              </div>

              {/* Step 3: Start Taking Orders */}
              <div className="relative bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-2xl transition-shadow duration-300 transform hover:scale-105 group">
                <div className="mb-4">
                  <FaShoppingCart
                    size={40}
                    className="mx-auto text-yellow-500 transition-transform duration-300 hover:rotate-12"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                  3. Start Taking Orders
                </h3>
                <p className="text-gray-600">
                  Connect with customers and start receiving orders right from
                  their tables!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="bg-white py-16">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            Why Choose FoodOrderoo?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Affordable Pricing */}
            <div className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <FaDollarSign className="text-yellow-500 text-5xl mb-4 mx-auto transition-transform duration-300 hover:rotate-12" />
              <h3 className="text-xl font-semibold mb-2">
                No fees for restaurants
              </h3>
              <p className="text-gray-600">
                Get started with a no upfront registration fee. Plus, there's
                just a small fee of $1 per order.
              </p>
            </div>

            {/* Save on Labor Costs */}
            <div className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <FaUsers className="text-blue-500 text-5xl mb-4 mx-auto transition-transform duration-300 hover:rotate-12" />
              <h3 className="text-xl font-semibold mb-2">
                Save on Labor Costs
              </h3>
              <p className="text-gray-600">
                By allowing customers to place their orders directly on their
                phones, restaurant owners can significantly reduce labor costs.
                No need for extra staff to take orders at the table!
              </p>
            </div>

            {/* Dedicated Support */}
            <div className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <FaHeadset className="text-purple-500 text-5xl mb-4 mx-auto transition-transform duration-300 hover:rotate-12" />
              <h3 className="text-xl font-semibold mb-2">Dedicated Support</h3>
              <p className="text-gray-600">
                Our team is here to support you every step of the way. Whether
                you have questions about managing your menu or handling orders,
                we're just a message away!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            What Our Users Say
          </h2>
          <div className="bg-gray-100 p-6 rounded-lg shadow-lg max-w-3xl mx-auto">
            <p className="text-xl text-gray-700 mb-4">
              "{testimonials[currentTestimonialIndex].message}"
            </p>
            <p className="text-lg font-semibold text-gray-800 mb-4">
              - {testimonials[currentTestimonialIndex].name}
            </p>
            <div className="flex justify-center">
              {[...Array(testimonials[currentTestimonialIndex].rating)].map(
                (_, index) => (
                  <FaStar key={index} className="text-yellow-400" />
                )
              )}
              {[...Array(5 - testimonials[currentTestimonialIndex].rating)].map(
                (_, index) => (
                  <FaStar key={index} className="text-gray-300" />
                )
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section className="bg-blue-600 text-white py-16">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-8">Get in Touch</h2>
          <p className="mb-4">Have any questions? </p>
          <p className="mb-2">
            <Link to="/feedback" className="underline">
              Message us
            </Link>
          </p>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
